export const IMG = {
  heroBar: "https://images.pexels.com/photos/14882031/pexels-photo-14882031.jpeg",
  bar2: "https://images.pexels.com/photos/26729557/pexels-photo-26729557.jpeg",
  coupe: "https://images.unsplash.com/photo-1617736674449-cf6da37a51f2?w=900",
  oldfashioned: "https://images.unsplash.com/photo-1665609951801-ff3f25c0f0f1?w=900",
  amberhand: "https://images.pexels.com/photos/17846727/pexels-photo-17846727.jpeg?w=900",
  spritz: "https://images.unsplash.com/photo-1678406497998-191819389726?w=900",
  wedding: "https://images.unsplash.com/photo-1613256253373-352901921b9c?w=900",
  toast: "https://images.unsplash.com/photo-1527529482837-4698179dc6ce?w=900",
  champagne: "https://images.unsplash.com/photo-1707707178778-bec9382d152c?w=900",
  margarita: "https://images.unsplash.com/photo-1556855810-ac404aa91e85?w=900",
  tropical: "https://images.unsplash.com/photo-1551024709-8f23befc6f87?w=900",
  shelves: "https://images.unsplash.com/photo-1763688459566-32c3d53f724b?w=900",
};
